import {Lang, useCompetitionImamrezaContext} from '@context/CompetitionImamrezaContext';
import {Box} from '@mui/material';
import {getSafeLangImage} from '@utils';
import React, {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import bg from './assets/images/m1/bg.webp';
import box from './assets/images/m1/box.webp';
import desc_ar from './assets/images/m1/desc-ar.webp';
import desc_en from './assets/images/m1/desc-en.webp';
import desc_fa from './assets/images/m1/desc-fa.webp';
import haram from './assets/images/m1/haram.webp';
import title_ar from './assets/images/m1/title-ar.webp';
import title_en from './assets/images/m1/title-en.webp';
import title_fa from './assets/images/m1/title-fa.webp';
import help_ar from './assets/images/m1/help-ar.webp';
import help_en from './assets/images/m1/help-en.webp';
import help_fa from './assets/images/m1/help-fa.webp';
import helpb_ar from './assets/images/m1/helpb-ar.webp';
import helpb_en from './assets/images/m1/helpb-en.webp';
import helpb_fa from './assets/images/m1/helpb-fa.webp';
import title from './assets/images/m1/title.webp';

type IProps = {}
const titleImage: Record<Lang, string> = {
	en: title_en,
	fa: title_fa,
	ar: title_ar
};
const helpbImage: Record<Lang, string> = {
	en: helpb_en,
	fa: helpb_fa,
	ar: helpb_ar
};
const helpImage: Record<Lang, string> = {
	en: help_en,
	fa: help_fa,
	ar: help_ar
};
const descImage: Record<Lang, string> = {
	en: desc_en,
	fa: desc_fa,
	ar: desc_ar
};
export default function CompetitionGuide(props: IProps) {
	const {t} = useTranslation();
	const navigate = useNavigate();
	const [helpOpen, setHelpOpen] = useState(false);
	const helpBoxRef = useRef<HTMLDivElement>(null);
	const helpButtonRef = useRef<HTMLDivElement>(null);
	const {
		competition,
		mission,
		setMission,
		results,
		setResults,
		lang
	} = useCompetitionImamrezaContext();
	
	// Close help box if clicked outside
	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (
				helpOpen &&
				helpBoxRef.current &&
				!helpBoxRef.current.contains(event.target as Node) &&
				helpButtonRef.current &&
				!helpButtonRef.current.contains(event.target as Node)
			) {
				setHelpOpen(false);
			}
		};
		
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [helpOpen]);
	
	return (
		<Box
			className="w-full h-full min-h-[800px] overflow-y-auto justify-center align-middle relative bg-[#0D6580]"
			sx={{
				backgroundImage: `url(${bg})`,
				backgroundRepeat: 'no-repeat',
				backgroundSize: 'cover'
			}}
		>
			<div className="flex flex-col justify-start w-10/12 h-full items-center mx-auto">
				<div className="flex flex-col justify-center w-full h-fit gap-y-3 mt-10 items-center relative">
					<img className="w-full" src={getSafeLangImage(titleImage, lang)} alt="title"/>
				</div>
				
				<div className="w-full h-fit  flex flex-col justify-center items-center absolute bottom-0 left-0 mx-auto">
					<img className="w-fit h-48 absolute bottom-[50%] mx-auto" src={getSafeLangImage(descImage, lang)} alt="desc"/>
					
					{/* Help Button */}
					<div
						ref={helpButtonRef}
						className="w-14 h-fit cursor-pointer z-20 absolute bottom-[25%] right-[20px]"
						onClick={() => setHelpOpen(!helpOpen)}
					>
						<img className="w-full h-fit mx-auto" src={getSafeLangImage(helpbImage, lang)} alt="help"/>
					</div>
					
					{/* Help Box styled like a dialog with background image */}
					{helpOpen && (
						<div
							ref={helpBoxRef}
							className="w-9/12 h-[70%] absolute z-30 bottom-[25%] right-[17%] bg-no-repeat bg-contain bg-bottom flex flex-row items-end justify-end"
							style={{
								backgroundImage: `url(${box})`
								// aspectRatio: '1 / 1'
							}}
							onClick={() => setHelpOpen(false)}
						>
							<img className="w-9/12 h-fit ml-5 mb-5" src={getSafeLangImage(helpImage, lang)} alt="help"/>
						</div>
					)}
					
					<img
						src={haram}
						alt="haram"
						className="w-full h-fit z-10 cursor-pointer"
						onClick={() => setMission(2)}
					/>
				</div>
			</div>
		</Box>
	);
}
